{ "imageTag": "20261104051324_a31017d", "buildUri": "vstfs:///Build/Build/104019", "buildId": "104019", "sourceCommit": "a31017d413c59c9b94a46c35e33fcf48427dd565", "sourceBranch": "main", "releaseDate": "2026-11-04T05:16:32Z" }
